import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_pos-r _bgc--white _rounded--common gfu-background-swept",
  "data-qa": "project-card-skeleton"
}
const _hoisted_2 = { class: "_flexrow" }
const _hoisted_3 = { class: "_pa-3 _grow-1" }
const _hoisted_4 = { class: "_flexcol _pa-3 _gap-2 _grow-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_button = _resolveComponent("skeleton-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_skeleton_image)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_skeleton_line, { height: 28 }),
        _createVNode(_component_skeleton_line),
        _createVNode(_component_skeleton_line),
        _createVNode(_component_skeleton_line),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "_grow-1" }, null, -1 /* CACHED */)),
        _createVNode(_component_skeleton_button)
      ])
    ])
  ]))
}